import React from 'react';
import {Link} from "react-router-dom";
import Logo from '../../components/logo/Logo';

const Footer = () => {
    return (
        <div className="footer-section section footer-bg-color">
            <div className="container text-center">
                    <div className="footer-widget">
                        <div className="footer-logo">
                            <Logo
                                image={`${process.env.PUBLIC_URL}/images/logo/footer-logo.webp`}
                            />
                        </div>
                        <div className="footer-widget-content">
                            <div className="content">
                                <p><Link to="tel:703-213-7591">703-213-7591</Link></p>
                                <p><Link to="mailto:info@foundersinsulation.com">info@foundersinsulation.com</Link></p>
                            </div>
                            <div className="footer-social-inline">
                                <a href="https://www.facebook.com/foundersinsulation"><i className="fab fa-facebook-square fa-large"></i></a>
                                <a href="https://www.instagram.com/foundersinsulation/"><i className="fab fa-instagram fa-large"></i></a>
                                <a href="https://www.facebook.com/foundersinsulation"><i className="fab fa-linkedin-in fa-large"></i></a>
                            </div>
                            <div className="content">
                                <p style={{"font-size": "16px", "text-align": "center", "margin-left": "3em"}}>
                                    <Link to={process.env.PUBLIC_URL + "/privacy-policy"}>Privacy Policy</Link> | <Link to={process.env.PUBLIC_URL + "/accessibility-statement"}>Accessibility Statement</Link>
                                </p>
                            </div>
                        </div>
                </div>

                <div className="row">
                    <div className="col">
                        <p className="copyright">&copy; {new Date().getFullYear()} <strong>Founders Insulation</strong></p>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Footer
